// extracted by mini-css-extract-plugin
export default {"banner":"aura-in-progress-banner_banner__18pbs"};